import { render, staticRenderFns } from "./LoadingInline.vue?vue&type=template&id=bfa8b236&scoped=true"
import script from "./LoadingInline.vue?vue&type=script&lang=js"
export * from "./LoadingInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8b236",
  null
  
)

export default component.exports